export interface ResolveQuestionLocaleValuesParams {
  questionKey?: string;
  answerKeys?: string[];
  descInlineKey?: string | null;
  descKey?: string | null;
  exampleKey?: string | null;
  fallbackQuestionLabel?: string;
  fallbackAnswerLabels?: Record<string, string>;
  fallbackDescInlineValue?: string;
  fallbackDescValue?: string;
  fallbackExampleValue?: string;
  translationValues?: Record<string, string>;
}

export interface ResolvedQuestionLocaleValues {
  questionLabel: string;
  answerLabels: Record<string, string>;
  descInlineValue: string;
  descValue: string;
  exampleValue: string;
}

function pickTranslatedValue({
  key,
  fallback,
  translationValues,
}: {
  key?: string | null;
  fallback: string;
  translationValues: Record<string, string>;
}): string {
  if (!key) return fallback;
  const translated = translationValues[key];
  if (typeof translated !== 'string') return fallback;
  return translated;
}

export function resolveQuestionLocaleValues({
  questionKey,
  answerKeys = [],
  descInlineKey,
  descKey,
  exampleKey,
  fallbackQuestionLabel = '',
  fallbackAnswerLabels = {},
  fallbackDescInlineValue = '',
  fallbackDescValue = '',
  fallbackExampleValue = '',
  translationValues = {},
}: ResolveQuestionLocaleValuesParams): ResolvedQuestionLocaleValues {
  const questionLabel = pickTranslatedValue({
    key: questionKey,
    fallback: fallbackQuestionLabel,
    translationValues,
  });

  const answerLabels = answerKeys.reduce<Record<string, string>>((acc, key) => {
    acc[key] = pickTranslatedValue({
      key,
      fallback: fallbackAnswerLabels[key] ?? '',
      translationValues,
    });
    return acc;
  }, {});

  const descInlineValue = pickTranslatedValue({
    key: descInlineKey,
    fallback: fallbackDescInlineValue,
    translationValues,
  });
  const descValue = pickTranslatedValue({
    key: descKey,
    fallback: fallbackDescValue,
    translationValues,
  });
  const exampleValue = pickTranslatedValue({
    key: exampleKey,
    fallback: fallbackExampleValue,
    translationValues,
  });

  return {
    questionLabel,
    answerLabels,
    descInlineValue,
    descValue,
    exampleValue,
  };
}
